import { EmbeddedDefaultPayoutMethod } from "../components/EmbeddedDefaultPayoutMethod";

export const RouteDefaultPayoutMethod = () => {
  return <EmbeddedDefaultPayoutMethod />;
};
